(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4737],{

/***/ 20640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(11742);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 87559:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wishlist",
      function () {
        return __webpack_require__(89061);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37444);
/* harmony import */ var _components_Abstracts_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87407);
/* harmony import */ var _providers_ThemeProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5672);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5114);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()));
function LoadingPage(param) {
    var color = param.color, className = param.className;
    var colors = (0,_providers_ThemeProvider__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .F)().colors;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().loader), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Abstracts_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().spinner),
            color: colors === null || colors === void 0 ? void 0 : colors[color !== null && color !== void 0 ? color : _types_colors__WEBPACK_IMPORTED_MODULE_3__/* .GlobalThemeColors.Black */ .b.Black]
        })
    });
}
LoadingPage.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingPage);


/***/ }),

/***/ 839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withAuthentication; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96660);
/* harmony import */ var _components_Abstracts_LoadingPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11459);
/* harmony import */ var _hooks_account_useAuthentication__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87146);







function withAuthentication(WrappedComponent) {
    var HOC = function(pageProps) {
        var ref = (0,_hooks_account_useAuthentication__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .SINGLE_ROUTES.login.href */ .OG.login.href, null), isInitialLoading = ref.isInitialLoading, customer = ref.data;
        return isInitialLoading || !customer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Abstracts_LoadingPage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    }, "robots")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, pageProps))
            ]
        });
    };
    return HOC;
}


/***/ }),

/***/ 87146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAuthentication; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98028);





function useAuthentication(redirectOnError, redirectOnSuccess) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        redirectOnError && router.prefetch(redirectOnError);
        redirectOnSuccess && router.prefetch(redirectOnSuccess);
    }, []);
    var _ref = (0,_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useGetCustomer */ ._)({
        refetchOnMount: true,
        keepPreviousData: true,
        retry: 0,
        onSuccess: function(data) {
            data && redirectOnSuccess && router.replace(redirectOnSuccess);
            !data && redirectOnError && router.replace(redirectOnError);
        }
    }), fetchStatus = _ref.fetchStatus, isSuccess = _ref.isSuccess, profileQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "fetchStatus",
        "isSuccess"
    ]);
    var shouldRedirectOnError = fetchStatus === "idle" && redirectOnError && !(profileQuery === null || profileQuery === void 0 ? void 0 : profileQuery.data);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (shouldRedirectOnError) {
            redirectOnError && router.replace(redirectOnError);
        }
    }, [
        shouldRedirectOnError
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        isIdle: fetchStatus === "idle",
        isSuccess: isSuccess
    }, profileQuery);
}


/***/ }),

/***/ 89061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ wishlist; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(20640);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/components/Abstracts/Spinner/index.tsx
var Spinner = __webpack_require__(87407);
// EXTERNAL MODULE: ./src/components/Abstracts/Storyblok/index.ts + 1 modules
var Storyblok = __webpack_require__(9222);
// EXTERNAL MODULE: ./src/components/UI/ProductCard/index.tsx + 8 modules
var ProductCard = __webpack_require__(23816);
// EXTERNAL MODULE: ./src/components/UI/SquaredCta/index.tsx
var SquaredCta = __webpack_require__(35007);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/hooks/useAlerts/index.ts
var useAlerts = __webpack_require__(827);
// EXTERNAL MODULE: ./src/hooks/wishlist/useGetWishlist/index.ts
var useGetWishlist = __webpack_require__(90191);
;// CONCATENATED MODULE: ./src/utils/get-shared-wishlist-public-url.ts
function getSharedWishlistPublicUrl(wishlistLid) {
    if (!wishlistLid) return null;
    return "".concat("https://www.whitebirdjewellery.com", "/wishlist/").concat(wishlistLid);
}
/* harmony default export */ var get_shared_wishlist_public_url = (getSharedWishlistPublicUrl);

// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/UI/Wishlist/styles.module.scss
var styles_module = __webpack_require__(53986);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Wishlist/index.tsx



















var cx = bind_default().bind((styles_module_default()));
var CARD_SIZES = [
    {
        breakpoint: "md",
        ratio: 1 / 4
    },
    {
        ratio: 1
    }
];
function Wishlist(param) {
    var className = param.className, title = param.title, emptyTitle = param.emptyTitle, upsales = param.upsales, shareMessageBody = param.shareMessageBody, shareMessageHead = param.shareMessageHead;
    var ref, ref1;
    var ref2 = (0,useGetWishlist/* useGetWishList */.z)(), data = ref2.data, isLoading = ref2.isLoading;
    var t = (0,lib/* useTranslate */.qM)();
    var triggerAlert = (0,useAlerts/* default */.Z)();
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title40SangBleu */.C.Title40SangBleu,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var subtitleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var urlStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title15SangBleu */.C.Title15SangBleu,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var empty = !isLoading && (data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.length) === 0;
    var sharedWishlistPublicUrl = get_shared_wishlist_public_url(data === null || data === void 0 ? void 0 : data.wishlistLid);
    var emailObject = shareMessageHead;
    var emailMessage = "".concat(shareMessageBody, " ").concat(sharedWishlistPublicUrl);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: cx(className, (styles_module_default()).Wishlist),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: gridStyle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).head,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: titleStyle,
                            children: (0,Storyblok/* asText */.S)(empty ? emptyTitle : title)
                        })
                    }),
                    sharedWishlistPublicUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).shareLinkWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: cx((styles_module_default()).copyButtonWrapper, urlStyle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (styles_module_default()).url,
                                        children: sharedWishlistPublicUrl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, {
                                        className: (styles_module_default()).button,
                                        withBorder: false,
                                        withHover: false,
                                        onClick: function() {
                                            copy_to_clipboard_default()(sharedWishlistPublicUrl);
                                            triggerAlert("COPY_SUCCESS");
                                        },
                                        children: t(dictionary/* CTA.COPY */.MV.COPY)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, {
                                className: (styles_module_default()).mailLink,
                                withBorder: false,
                                withHover: false,
                                href: "mailto:?subject=".concat(emailObject, "&body=").concat(emailMessage),
                                children: t(dictionary/* GENERAL.EMAIL */.vh.EMAIL)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).grid,
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).spinnerWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                className: (styles_module_default()).spinner
                            })
                        }) : !empty && data.products.map(function(product) {
                            var ref, ref1, ref2;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                sizesFromBreakpoints: CARD_SIZES,
                                wishlistDetails: {
                                    inList: product === null || product === void 0 ? void 0 : (ref = product.wishlistDetails) === null || ref === void 0 ? void 0 : ref.inList,
                                    variantId: product === null || product === void 0 ? void 0 : (ref1 = product.wishlistDetails) === null || ref1 === void 0 ? void 0 : ref1.variantId,
                                    tags: product === null || product === void 0 ? void 0 : product.tags
                                },
                                isWishListCard: true
                            }, product === null || product === void 0 ? void 0 : product.product), "wishlist_item_".concat(product === null || product === void 0 ? void 0 : (ref2 = product.product) === null || ref2 === void 0 ? void 0 : ref2.id));
                        })
                    })
                ]
            }),
            upsales && (upsales === null || upsales === void 0 ? void 0 : upsales.length) > 0 && !isLoading && (data === null || data === void 0 ? void 0 : (ref1 = data.products) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx(gridStyle, (styles_module_default()).gridBody),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: cx((styles_module_default()).subtitle, subtitleStyle),
                        children: t(dictionary/* SEARCH.MOST_POPULAR */.mo.MOST_POPULAR)
                    }),
                    upsales === null || upsales === void 0 ? void 0 : upsales.map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                            className: (styles_module_default()).item,
                            isWishListCard: true
                        }, product), "upsale_".concat(index));
                    })
                ]
            })
        ]
    });
}
Wishlist.defaultProps = {};
/* harmony default export */ var UI_Wishlist = (Wishlist);

// EXTERNAL MODULE: ./src/hocs/withAuthentication.tsx
var withAuthentication = __webpack_require__(839);
;// CONCATENATED MODULE: ./src/pages/wishlist/index.tsx




function WishlistPage(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_Wishlist, (0,_object_spread/* default */.Z)({}, props));
}
var __N_SSG = true;
/* harmony default export */ var wishlist = ((0,withAuthentication/* default */.Z)(WishlistPage));


/***/ }),

/***/ 5114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__6e9OI","spinner":"styles_spinner__Xp_RE"};

/***/ }),

/***/ 53986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Wishlist":"styles_Wishlist__SqsQ6","head":"styles_head__3GSKf","shareLinkWrapper":"styles_shareLinkWrapper__VApqy","grid":"styles_grid__NUAxN","copyButtonWrapper":"styles_copyButtonWrapper__NkoI1","url":"styles_url__EPMnE","button":"styles_button__qWorH","mailLink":"styles_mailLink__60q1w","popularProductsTitle":"styles_popularProductsTitle__tgGiX","spinnerWrapper":"styles_spinnerWrapper__dLYy9","spinner":"styles_spinner__T_P5b","gridBody":"styles_gridBody__mI4t6","subtitle":"styles_subtitle__yycmE","item":"styles_item__7zFdW"};

/***/ }),

/***/ 11742:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,7130,2873,3816,9774,2888,179], function() { return __webpack_exec__(87559); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);